import api from '@/api/client';

interface ApiEnvelope<T> {
  isStatus: boolean;
  message: string;
  data: T;
}

export interface CreateOrderResponse {
  order_id: string;
  amount: number;
  currency: string;
  key_id: string;
}

export interface VerifyPaymentRequest {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
  print_request: number | string;
}

export interface VerifyPaymentResponse {
  status: 'captured';
  otp: string;
  otp_expires_at: string | null;
}

export const paymentGatewayService = {
  createOrder: (printRequestId: number | string) =>
    api.post<ApiEnvelope<CreateOrderResponse>>('/payments/orders/create/', {
      print_request: printRequestId,
    }),

  verifyPayment: (payload: VerifyPaymentRequest) =>
    api.post<ApiEnvelope<VerifyPaymentResponse>>('/payments/verify/', payload),
};